import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  PAGE_DETAIL_FETCH,
  PAGE_DETAIL_SUCCESS,
  PAGE_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { PAGE_FORM_NAME } from '../PageForm/constants';

//<<<---PAGE-DETAIL--->>>
export const pageDetailFetch = createAction(PAGE_DETAIL_FETCH);
export const pageDetailSuccess = createAction(PAGE_DETAIL_SUCCESS);
export const pageDetailFailure = createAction(PAGE_DETAIL_FAILURE);

export const fetchPageDetail = (id, lang) => async dispatch => {
  dispatch(pageDetailFetch());
  try {
    const { data } = await api.get(`page/${id}/${lang}`);

    const fieldNames = [
      'id',
      'title',
      'description',
      'header',
      'headerImageSmall',
      'image',
      'slug',
      'subtitle',
      'content'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(PAGE_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(PAGE_FORM_NAME, 'headerImageLarge', {
        src: data.headerImageLarge
      })
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(pageDetailSuccess());
  } catch (error) {
    dispatch(pageDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/PageDetail/actions.js